"use client";
import { signIn } from "next-auth/react";
function LoginButton({
  isAuthenticated,
}: {
  text: string;
  isAuthenticated: boolean;
}) {
  return (
    <button
      className="whitespace-no-wrap focus:shadow-outline-blue inline-flex items-center justify-center rounded-md border border-transparent bg-blue-600 px-4 py-2 text-base font-medium leading-6 text-white transition duration-150 ease-in-out hover:bg-blue-500 focus:border-blue-700 focus:outline-none active:bg-blue-700"
      onClick={() => signIn("auth0")}
    >
      {isAuthenticated ? "Logout" : "Login"}
    </button>
  );
}

export default LoginButton;
